import axios from "axios";
import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";
import SonicTerm from "../../../common/classes/SonicTerm";

/**
 * getTerms
 *
 * Fetches taxonomy data.
 *
 * @param type Term slug
 * @param page Current page for pagination
 * @param per_page Results per page
 * @param desc Whether or not results are ascending or descending
 *
 * @returns An array of terms.
 */

export const getTerms = async (
  type: string,
  page?: number,
  per_page?: number,
  search?: string,
  desc?: boolean
): Promise<{
  total_pages: number;
  page: number;
  total_entries: number;
  entries: SonicTerm[];
}> => {
  try {
    const res = await axios.get(getAPIRoot(APIRoutes.get.term), {
      params: {
        type: type,
        pg: page,
        per: per_page,
        s: search,
        desc: desc,
      },
    });

    if (res.data.result === false)
      return {
        total_pages: 0,
        page: 0,
        total_entries: 0,
        entries: [],
      };

    const tax: Array<SonicTerm> = [];

    res.data.message.items.forEach((e: any) => {
      const term = SonicTerm.parseFromAPIResponse(e);
      tax.push({ ...term });
    });

    return {
      total_pages: res.data.message.total_pages,
      page: res.data.message.page,
      total_entries: res.data.message.total_entries,
      entries: tax,
    };
  } catch (e) {
    return {
      total_pages: 0,
      page: 0,
      total_entries: 0,
      entries: [],
    };
  }
};
